export default {
  isPreparingApp(state: any): boolean {
    return state.loading || state.initializing
  },
  isPreparingUsageData(state: any): boolean {
    return state.loadingUsage || state.initializing
  },
}
